export const BarChartPrimaryColor = {
  linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
  stops: [
    [0, '#7551FF'],
    [1, '#3311DB'],
  ],
} as Highcharts.ColorString | Highcharts.GradientColorObject | Highcharts.PatternObject;
